import { BaseDelayType } from './BaseDelayType'
import { DelayType } from './types'

export class DelayDateType extends BaseDelayType {
  declare type: DelayType.Date
  time!: string
}
